export default {
  isLoggedIn: ({ currentUser }) => Object.keys(currentUser ?? {}).length > 0,
  isSuperUser: ({ currentUser }) => currentUser?.acl === 'Admin',
};
